import { useProductVariants } from '@jetshop/core/hooks/useProductVariants';
import t from '@jetshop/intl';
import {
  DropdownMenu,
  DropdownMenuButton,
  DropdownMenuItem,
  DropdownMenuItems
} from '@jetshop/ui/DropdownMenu';
import { ReactComponent as Check } from '@jetshop/ui/svg/Check.svg';
import React from 'react';
import { styled } from 'linaria/react';
import { ReactComponent as AngleDown } from '../../svg/fa/angle-down.svg';
import { usePersistFavoriteVariant } from './usePersistFavoriteVariant';

export const StyledDropdownMenu = styled(DropdownMenu)`
  margin-bottom: 0.5rem;
`;

export const StyledDropdownMenuButton = styled(DropdownMenuButton)`
  background: #fff !important;
  border-radius: 0 !important;
  border-color: #000 !important;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 0.25rem;
  outline: none;
  text-align: left;
  svg {
    width: 10px;
  }
`;

export const StyledDropdownMenuItems = styled(DropdownMenuItems)`
  border: 1px solid #ddd;
  border-top: 0 !important;
  margin-top: -1px;
`;

export const StyledDropdownMenuItem = styled(DropdownMenuItem)`
  font-size: 12px;
  outline: none;
  transition: all ease 0.3s;
  :hover {
    background: #f3f3f3;
  }
`;

export function SelectVariant({ product }) {
  const persistVariant = usePersistFavoriteVariant(product);

  const {
    selectValue,
    getSelectedValue,
    validateSelection,
    getVariantForSelection
  } = useProductVariants(product, {
    initialVariant: product.variant
  });

  return (
    <>
      {product.variants.options.map(option => {
        const selectedValue = getSelectedValue(option);
        return (
          <StyledDropdownMenu key={option.name}>
            <StyledDropdownMenuButton>
              <span>
                {selectedValue
                  ? `${option.name}: ${selectedValue}`
                  : t.rich('Select {option}', { option: option.name })}
              </span>
              <span>
                <AngleDown />
              </span>
            </StyledDropdownMenuButton>
            <StyledDropdownMenuItems style={{ zIndex: 9999 }}>
              {option.values.map(value => {
                const validation = validateSelection(value, option);

                return (
                  <StyledDropdownMenuItem
                    key={value}
                    disabled={validation === 'invalid'}
                    closeOnSelect={true}
                    onSelect={() => {
                      const variant = getVariantForSelection(value, option);
                      selectValue(value, option);

                      if (variant) {
                        persistVariant(variant.articleNumber);
                      }
                    }}
                    style={{ opacity: validation !== 'invalid' ? 1 : 0.5 }}
                  >
                    {value}
                    {selectedValue === value && <Check />}
                  </StyledDropdownMenuItem>
                );
              })}
            </StyledDropdownMenuItems>
          </StyledDropdownMenu>
        );
      })}
    </>
  );
}
